import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { MeasuringInstrument } from '../types/MeasuringInstrument';

export const listMeasuringInstruments = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<MeasuringInstrument>> =>
  apiFetch('/measuring-instruments?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listMeasuringInstrumentsAll = (query?: string): Promise<MeasuringInstrument[]> =>
  apiFetch('/measuring-instruments/all' + (query ? ('?' + query) : ''));
export const getMeasuringInstrument = (id: number): Promise<MeasuringInstrument> => apiFetch('/measuring-instruments/' + id);
export const createMeasuringInstrument = (data: any): Promise<MeasuringInstrument> =>
  apiFetch('/measuring-instruments', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateMeasuringInstrument = (id: number, data: any): Promise<MeasuringInstrument> =>
  apiFetch('/measuring-instruments/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteMeasuringInstrument = (id: number): Promise<void> =>
  apiFetch('/measuring-instruments/' + id, { method: 'DELETE' });
